<template lang="html">
  <div>
    <h4 class="title">
      <span class="font-weight-bold">{{ title }}</span>
    </h4>
    <v-list v-if="isList" class="list-product">
      <template v-for="(item, idx) in products">
        <v-list-item :key="idx + '-product'" :disabled="checkDisabled(item)" :ripple="false" :class="[{ 'product_outstock': checkDisabled(item) }]" @click="showdata(item)">
          <v-list-item-avatar class="list-img-square list-with-favorite">
            <img :src="!$isEmpty(objDefaultVariant(item)) ? objDefaultVariant(item).photo_xs : item.photo_xs" @error="imageLoadError" @click.stop="viewImage(item.photo_md)">
            <v-btn v-if="item.is_favorite" color="white" dark x-small absolute bottom fab class="__btn-fav-list" @click.stop="removeFavorite(item.favorite_id, idx)">
              <v-icon color="red">
                mdi-heart
              </v-icon>
            </v-btn>
            <v-btn v-else color="white" dark x-small absolute bottom fab class="__btn-fav-list" @click.stop="createFavorite(item.id, idx)">
              <v-icon color="grey lighten-1">
                mdi-heart
              </v-icon>
            </v-btn>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title :class="[{ 'mb-2': item.alt_name === '' }]">
              {{ !$isEmpty(objDefaultVariant(item)) ? item.name + ' - ' + objDefaultVariant(item).name : item.name }}
            </v-list-item-title>
            <v-list-item-title v-if="item.alt_name !== ''" class="mb-2">
              {{ !$isEmpty(objDefaultVariant(item)) && objDefaultVariant(item).alt_name !== '' ? item.alt_name + ' - ' + objDefaultVariant(item).alt_name : item.alt_name }}
            </v-list-item-title>
            <!-- <v-list-item-subtitle v-if="item.variants != ''">
              <template v-for="(child, key) in item.variants">
                {{ child.name }}
                <span v-if="(item.variants.length - key) != 1" :key="key + '-plus'" v-html="'/'" />
              </template>
            </v-list-item-subtitle> -->
            <v-list-item-subtitle>
              {{ item.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="text-right qty-notes">
            <div class="__productInCart d-flex">
              <transition name="fade">
                <div v-if="item.__cart_data.note" class="__noteProduct grey lighten-2 mr-2 px-1">
                  <v-icon color="white" size="14">
                    mdi-file-document-outline
                  </v-icon>
                </div>
              </transition>
              <transition :duration="{ enter: 2000 }" name="slide-fade">
                <div v-if="item.__cart_data.qty" class="__qtyProduct primary--text font-weight-bold">
                  {{ item.__cart_data.qty }}x
                </div>
              </transition>
            </div>
            <template v-if="checkStock(item) || item.is_out_stock || item.__cart_data.is_available === false">
              <v-list-item-subtitle class="font-weight-bold txt-not-available">
                {{ $t('not_available') }}
              </v-list-item-subtitle>
            </template>
            <template v-else>
              <template v-if="Number(item.pos_sell_price_dynamic) === 1 && Number($store.state.selected_outlet.setting.pos_dynamic_price_can_order) === 0">
                <v-list-item-subtitle class="font-weight-bold txt-price-dynamic">
                  {{ $t('order_at_cashier') }}
                </v-list-item-subtitle>
              </template>
              <template v-else>
                <v-list-item-subtitle class="font-weight-bold __col-price">
                  <span v-if="$usePosPrice()" v-mask-money-only="!$isEmpty(objDefaultVariant(item)) ? objDefaultVariant(item).sell_price_pos : item.sell_price_pos" />
                  <span v-else v-mask-money-only="!$isEmpty(objDefaultVariant(item)) ? objDefaultVariant(item).sell_price : item.sell_price" />
                  <span v-if="(!$isEmpty(objDefaultVariant(item)) ? Number(objDefaultVariant(item).market_price) : Number(item.market_price)) !== 0" v-mask-money-only="!$isEmpty(objDefaultVariant(item)) ? Number(objDefaultVariant(item).market_price) : Number(item.market_price)" class="market-price" />
                </v-list-item-subtitle>
              </template>
            </template>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
    <v-row v-else>
      <v-col v-for="(item, idx) in products" :key="idx + '-product'" :cols="6" :sm="6">
        <div :class="['item-product-grid p-relative', { 'disable': disabled(item) || checkStock(item) || !item.__cart_data.is_available }]" @click="!(disabled(item) || checkStock(item) || !item.__cart_data.is_available) && showdata(item)">
          <div class="item-product-grid-wrap">
            <div class="item-product-grid-avatar">
              <img :src="!$isEmpty(objDefaultVariant(item)) ? objDefaultVariant(item).photo_md : item.photo_md" class="image-avatar" @error="imageLoadError">
              <div style="position: absolute; top: 8px; left: 8px;">
                <v-btn v-if="item.is_favorite" color="white" dark x-small fab @click.stop="removeFavorite(item.favorite_id, idx)">
                  <v-icon color="red">
                    mdi-heart
                  </v-icon>
                </v-btn>
                <v-btn v-else color="white" dark x-small fab @click.stop="createFavorite(item.id, idx)">
                  <v-icon color="grey lighten-1">
                    mdi-heart
                  </v-icon>
                </v-btn>
              </div>
            </div>
            <div class="item-product-grid-content">
              <div class="item-product-grid-title">
                {{ !$isEmpty(objDefaultVariant(item)) ? item.name + ' - ' + objDefaultVariant(item).name : item.name }}
              </div>
              <div v-if="item.alt_name !== ''" class="item-product-grid-title">
                {{ !$isEmpty(objDefaultVariant(item)) && objDefaultVariant(item).alt_name !== '' ? item.alt_name + ' - ' + objDefaultVariant(item).alt_name : item.alt_name }}
              </div>
              <div class="item-product-grid-price d-flex align-center mt-2">
                <div v-if="Number(item.pos_sell_price_dynamic) === 1 && Number($store.state.selected_outlet.setting.pos_dynamic_price_can_order) === 0" class="font-weight-bold item-product-grid-price-dynamic">
                  {{ $t('order_at_cashier') }}
                </div>
                <div v-else class="font-weight-bold d-flex align-center">
                  <span v-if="$usePosPrice()" v-mask-money-only="!$isEmpty(objDefaultVariant(item)) ? objDefaultVariant(item).sell_price_pos : item.sell_price_pos" />
                  <span v-else v-mask-money-only="!$isEmpty(objDefaultVariant(item)) ? objDefaultVariant(item).sell_price : item.sell_price" />
                  <template v-if="(!$isEmpty(objDefaultVariant(item)) ? Number(objDefaultVariant(item).market_price) : Number(item.market_price)) !== 0">
                    <span v-mask-money-only="!$isEmpty(objDefaultVariant(item)) ? Number(objDefaultVariant(item).market_price) : Number(item.market_price)" class="item-product-grid-market-price" />
                    <span class="ml-1 d-flex align-center">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 1C5.6325 1 5.76 1.0525 5.8535 1.1465L10.8535 6.1465C11.049 6.342 11.049 6.658 10.8535 6.8535L6.8535 10.8535C6.756 10.951 6.628 11 6.5 11C6.372 11 6.244 10.951 6.1465 10.8535L1.1465 5.8535C1.0525 5.76 1 5.633 1 5.5V3C1 2.867 1.0525 2.74 1.1465 2.6465L2.6465 1.1465C2.74 1.0525 2.8675 1 3 1H5.5ZM2 5.293L6.5 9.793L9.793 6.5L5.293 2H3.207L2 3.207V5.293ZM5.00003 4.1765C5.00003 4.6313 4.63133 5 4.17653 5C3.72172 5 3.35303 4.6313 3.35303 4.1765C3.35303 3.72169 3.72172 3.353 4.17653 3.353C4.63133 3.353 5.00003 3.72169 5.00003 4.1765Z" fill="#F44336" />
                      </svg>
                    </span>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  setProductFavorite as setProductFav,
  delProductFavorite as delProductFav
} from '@/api/product'
export default {
  name: 'ListProduct',
  props: {
    isList: {
      type: Boolean,
      default: true
    },
    products: {
      required: true,
      type: Array
    },
    title: {
      default: '',
      type: String
    },
    showdata: {
      required: true,
      type: Function
    },
    viewImage: {
      required: true,
      type: Function
    },
    listincart: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      formFavorite: {
        product_id: ''
      }
    }
  },
  methods: {
    disabled() {
      if (!this.$isEmpty(this.$store.state.selected_outlet)) {
        const openStore = this.$store.state.selected_outlet.store_is_open === 1
        if (!openStore) {
          return true
        } else {
          if (this.$store.state.selected_type === 'DINE-IN' && this.$store.state.selected_outlet.setting.use_dinein === 1) {
            return false
          } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY' && this.$store.state.selected_outlet.setting.use_takeaway === 1) {
            return false
          } else if (this.$store.state.selected_type === 'DELIVERY' && this.$store.state.selected_outlet.setting.use_delivery === 1) {
            return false
          } else if (this.$store.state.selected_type === 'RESERVATION' && this.$store.state.selected_outlet.setting.use_reservation === 1) {
            return false
          } else {
            return true
          }
        }
      } else {
        return true
      }
    },
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    },
    async createFavorite(id, index) {
      this.formFavorite.product_id = id
      try {
        const { data } = await setProductFav(this.formFavorite)
        this.$store.state.loading_axios = false
        this.products[index].is_favorite = 1
        this.products[index].favorite_id = data.data.id
      } catch (e) {
        if (e.statusCode === 401) {
          const tmii_outlet = this.$store.state.store_tmii
          const url_id = this.$store.state.url_domain

          if (tmii_outlet.indexOf(url_id) !== -1) {
            this.$router.push({ name: 'login_guest', query: { redirect: this.$router.currentRoute.name }}).catch(() => {})
          } else {
            this.$router.push({ name: 'login', query: { redirect: this.$router.currentRoute.name }}).catch(() => {})
          }
        }
      }
    },
    async removeFavorite(id, index) {
      try {
        await delProductFav(id)
        this.$store.state.loading_axios = false
        this.products[index].is_favorite = 0
      } catch (e) {
        if (e.statusCode === 401) {
          const tmii_outlet = this.$store.state.store_tmii
          const url_id = this.$store.state.url_domain
          if (tmii_outlet.indexOf(url_id) !== -1) {
            this.$router.push({ name: 'login_guest', query: { redirect: this.$router.currentRoute.name }}).catch(() => {})
          } else {
            this.$router.push({ name: 'login', query: { redirect: this.$router.currentRoute.name }}).catch(() => {})
          }
        }
      }
    },
    objDefaultVariant(item) {
      try {
        if (!item || !Array.isArray(item.variants) || !item.default_variant_id) {
          return {}
        }
        const found = item.variants.find(v => v.id === item.default_variant_id)
        return found || {}
      } catch (e) {
        return {}
      }
    },
    checkDisabled(item) {
      return this.checkStock(item) || Number(item.is_out_stock) === 1 || item.__cart_data.is_available === false
    },
    checkStock(item) {
      if (typeof item.items !== 'undefined') {
        if (item.is_out_stock) {
          return true
        }
      } else {
        if (item.has_variant) {
          let isDisabled = true
          for (let i = 0; i < item.variants.length; i++) {
            const variant = item.variants[i]
            if (item.track_inventory) {
              if (!variant.is_out_stock && Number(variant.hold_qty) + this.$stockCart(variant.id, 'variant') < Number(variant.stock_qty)) {
                isDisabled = false
                break
              }
            } else {
              if (!variant.is_out_stock) {
                isDisabled = false
                break
              }
            }
          }
          return isDisabled
        } else {
          if (item.track_inventory) {
            if (item.is_out_stock || this.$stockCart(item.id) + Number(item.hold_qty) >= Number(item.stock_qty)) {
              return true
            }
          } else {
            if (item.is_out_stock) {
              return true
            }
          }
        }
      }
      return false
    }
  }
}
</script>
